// Requires: src/checkout-state.js

(function($, CheckoutState) {
	'use strict';

	var $form       = $('[data-checkout-promo]');
	var $input      = $form.find('[data-checkout-promo-input]');
	var $submit		= $form.find('[data-checkout-promo-submit]');
	var REQUEST_URL = $form.data('requestUrl');
	var $dataSourceItemId = $form.find('[data-source-Item-Id]');

	$submit.on('click', handleOptionSubmit);

	function handleOptionSubmit(e) {
	    e.preventDefault();
	    e.stopImmediatePropagation();
		var promoCode = $input.val();
		var dataSourceId = $dataSourceItemId.val();

	    $.post(REQUEST_URL, { promoCode: promoCode, dataSourceId: dataSourceId })
			.done(handleSuccess)
			.fail(handleFail);
	}

	function handleSuccess(data) {
		if(data.error) {
			// deal with the error
			CheckoutState.state.set(CheckoutState.state.type.promoAlert, data.promoAlert);
		} else {
			// Update the state
			$input.val('');
			CheckoutState.state.set(CheckoutState.state.type.summary, data.totals);
			CheckoutState.state.set(CheckoutState.state.type.promoAlert, data.promoAlert);
		}
	}

	function handleFail(e) {
		console.log('failed');
		console.log(e);
	}

})($jq, window.BOL.Checkout.State);
